import NavIcon from "components/NavIcon"
import { useLocation } from "react-router-dom"
import { AppParamsContext } from "contexts/AppParamsContext"
import { useContext } from "react"
import { isDesktop } from "react-device-detect"

export default function BottomBar() {
  const { appParams } = useContext(AppParamsContext)

  const location = useLocation()

  const path = location.pathname.split("/")[1]

  if (
    appParams?.navigation?.navbarElements == null ||
    appParams?.styles?.topBottomBar?.bottomBarVisible == null ||
    appParams?.styles?.topBottomBar?.bottomBarVisible === false
  )
    return null

  const addClass = isDesktop
    ? "absolute left-3 top-[105px] flex-col flex justify-around gap-2 overflow-auto bg-[var(--bottom-bar-bg-color)] shrink-0 p-2 rounded-[var(--general-border-radius)]"
    : appParams?.styles?.topBottomBar?.layout === "floating"
    ? "absolute flex flex-row w-[calc(100%-1rem)] bg-[var(--bottom-bar-bg-color)] rounded-full justify-between items-center px-2 py-2 bottom-10 z-50 mx-2"
    : "bottomBar-root"

  if (location.pathname.startsWith("/menu")) return null

  return (
    <section className={`${addClass} module-${path}`}>
      {(appParams?.navigation?.navbarElements || []).map((element, index) => (
        <NavIcon key={index} element={element} />
      ))}
    </section>
  )
}
